import {ADD_TO_CART, DECREASE_CART_QTY, INCREASE_CART_QTY} from "../cart/actionTypes";
import {DECREASE_PRODUCT_QTY, INCREASE_PRODUCT_QTY} from "../product/actionTypes";

/*
 * Middleware restrict the unusual data change.
 * User may enable the disabe button and request for add to cart.
 * It prevents that kind of maliscious actions
 */

const cartValidator = (store) => (next) => (action) => {
    const {product, cart} = store.getState();
    
    if ([DECREASE_PRODUCT_QTY, ADD_TO_CART, INCREASE_CART_QTY].includes(action.type)) {
        const item = product.find(p => p.id === action.payload);
        if (item === undefined || item.quantity <= 0) {
            return;
        }
    }
    
    if ([DECREASE_CART_QTY, INCREASE_PRODUCT_QTY].includes(action.type)) {
        const item = cart.find(c => c.id === action.payload);
        if (item === undefined || item.quantity <= 0) {
            return;
        }
    }
    
    return next(action);
}

export default cartValidator;